import apiClient from '../apiClient';

// Define la estructura de la marca
export interface Brand {
  id: number;
  name: string;
  logo: string;
  featured: boolean; 
}

// Esta función obtiene las marcas desde tu API
export const getBrands = async (): Promise<Brand[]> => {
  const response = await apiClient.get<Brand[]>('/api/brands/');
  return response.data; // Devuelve la lista de marcas
};
